module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_fiat_04.06f254af.jpg";